import { ls } from './local-storage';

const LOG_LEVEL_STORAGE_KEY = 'rpr_log_level';
const LOG_LEVEL = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  NONE: 'none',
  DEFAULT: 'default',
};

const isValueOfLogLevel = (level: string): boolean => Object.values(LOG_LEVEL).includes(level);

const canOutputLog = (type: string): boolean => {
  const logLevel = ls.get(LOG_LEVEL_STORAGE_KEY);
  if (!logLevel) return true;

  switch (logLevel) {
    case LOG_LEVEL.INFO:
      return ['error', 'warn', 'info'].includes(type);
    case LOG_LEVEL.WARN:
      return ['error', 'warn'].includes(type);
    case LOG_LEVEL.ERROR:
      return type === 'error';
    case LOG_LEVEL.NONE:
      return false;
    case LOG_LEVEL.DEFAULT:
      return true;
    default:
      // 通常の操作であればここに入ることはありえないはず
      return true;
  }
};

// うまく整理すると ErrorNotifier の有効無効の制御もまとめたモジュールにできるかもしれない
// ref. https://github.com/reproio/web-sdk/pull/263#issuecomment-469586581
export const console = {
  log(...args: any[]): void {
    if (canOutputLog('log')) {
      window.console.log(...args);
    }
  },
  info(...args: any[]): void {
    if (canOutputLog(LOG_LEVEL.INFO)) {
      window.console.info(...args);
    }
  },
  warn(...args: any[]): void {
    if (canOutputLog(LOG_LEVEL.WARN)) {
      window.console.warn(...args);
    }
  },
  error(...args: any[]): void {
    if (canOutputLog(LOG_LEVEL.ERROR)) {
      window.console.error(...args);
    }
  },
  memorizeLogLevel(logLevel: string = LOG_LEVEL.DEFAULT): void {
    if (!isValueOfLogLevel(logLevel)) {
      ls.set(LOG_LEVEL_STORAGE_KEY, LOG_LEVEL.DEFAULT);
      return console.error(`"${logLevel}" is not a valid log level value. Log level has been set to "default".`);
    }
    ls.set(LOG_LEVEL_STORAGE_KEY, logLevel);
  },
};
